(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fuji-newsletter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fuji-newsletter')) {
    customElements.define('fuji-newsletter', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.form?.querySelector('button[type="submit"]');
        this.pendingMessage = this.querySelector('.fuji-newsletter-signup__pending');
        this.pending = false;
        this.onSubmit = (event) => {
          if (this.pending) {
            event.preventDefault();
            return;
          }
          clearTimeout(this.pendingTimer);
          this.pendingTimer = setTimeout(() => {
            this.pendingTimer = null;
            if (event.defaultPrevented || !this.isConnected || !this.form.checkValidity()) return;
            this.pending = true;
            this.form.setAttribute('aria-busy', 'true');
            if (this.button) this.button.disabled = true;
            if (this.pendingMessage) this.pendingMessage.hidden = false;
          }, 0);
        };
        this.onPageShow = () => {
          clearTimeout(this.pendingTimer);
          this.pendingTimer = null;
          this.pending = false;
          this.form?.removeAttribute('aria-busy');
          if (this.button) this.button.disabled = false;
          if (this.pendingMessage) this.pendingMessage.hidden = true;
        };
        this.onPageShow();
        this.form?.addEventListener('submit', this.onSubmit);
        window.addEventListener('pageshow', this.onPageShow);
        const result = this.querySelector('[data-newsletter-result]');
        if (result) result.focus();
      }

      disconnectedCallback() {
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
        this.form?.removeEventListener('submit', this.onSubmit);
        window.removeEventListener('pageshow', this.onPageShow);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
